
import React from "react";


import { connect } from "react-redux";

import history from "../../auth/history";
import './Subtransaction.css';
import moment from "moment";
class SubTransactionDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			suTransactionStatus:'pending'
		}
    }



    componentDidMount(){


       
	}
	componentWillUnmount(){
    }



 

    

    render(){
		console.log('createOrderStatusRes',this.props.createOrderStatusResponse);

    return(
                            <div class="subtxn">
								<h4>Sub Transactions</h4>

								{(this.props.createOrderStatusResponse!=null &&
								this.props.createOrderStatusResponse!=undefined &&
								this.props.createOrderStatusResponse!='') &&
								this.props.createOrderStatusResponse.subOrders.map(txRsp=>(



									<div class={(txRsp.status=='PENDING'||txRsp.status=='INIT'||
									txRsp.status=='SUBMITTED')?'subtxn-pending':
									txRsp.status=='REVERSED'?'subtxn-failed':
									txRsp.status=='SUCCESS'?'subtxn-success':
									txRsp.status=='FAILED'&&'subtxn-failed'}>
									
									<div class="row">
										<div class="col-6 col-md-3 col-lg-4 order-md-1">
											<div class="subtxt txnsts">{(txRsp.status=='PENDING'||txRsp.status=='INIT'||
									txRsp.status=='SUBMITTED')?'Pending':
									txRsp.status=='REVERSED'?'Failed':
									txRsp.status=='SUCCESS'?'Success':
									txRsp.status=='FAILED'&&'Failed'}</div>
										</div>
										
										<div class="col-6 col-md-2 col-lg-2 order-md-4">
											<div class="subtxt subamunt rtxt">₹ {txRsp.txnDetails.amount}</div>
										</div>
										
										<div class="col-12 col-md-4 col-lg-3 order-md-2">
											<div class="subtxt subid">Transaction ID: {txRsp.id}</div>
										</div>
										
										<div class="col-12 col-md-3 col-lg-3 order-md-3">
										<div class="subtxt">{moment(this.props.createOrderStatusResponse.time).format('DD-MM-YYYY HH:mm:ss')}</div>
										</div>
									</div>
									</div>

									
								// 	(txRsp.status=='PENDING'||txRsp.status=='INIT'||
								// 	txRsp.status=='SUBMITTED') ?
								// 	<div class="subtxn-pending">
										
								// 	<div class="row">
								// 		<div class="col-6 col-md-3 col-lg-4 order-md-1">
								// 			<div class="subtxt txnsts">Pending</div>
								// 		</div>
										
								// 		<div class="col-6 col-md-2 col-lg-2 order-md-4">
								// 			<div class="subtxt subamunt rtxt">₹ {txRsp.txnDetails.amount}</div>
								// 		</div>
										
								// 		<div class="col-12 col-md-4 col-lg-3 order-md-2">
								// 			<div class="subtxt subid">Transaction ID: {txRsp.id}</div>
								// 		</div>
										
								// 		<div class="col-12 col-md-3 col-lg-3 order-md-3">
								// 			<div class="subtxt">{moment(this.props.createOrderStatusResponse.time).format('DD-MM-YYYY HH:mm:ss')}</div>
								// 		</div>
								// 	</div>
								// </div>
								// :
								// txRsp.status=='SUCCESS' ?
								// 	<div class="subtxn-success">
										
								// 	<div class="row">
								// 		<div class="col-6 col-md-3 col-lg-4 order-md-1">
								// 			<div class="subtxt txnsts">Successful</div>
								// 		</div>
										
								// 		<div class="col-6 col-md-2 col-lg-2 order-md-4">
								// 			<div class="subtxt subamunt rtxt">₹ {txRsp.txnDetails.amount}</div>
								// 		</div>
										
								// 		<div class="col-12 col-md-4 col-lg-3 order-md-2">
								// 			<div class="subtxt subid">Transaction ID: {txRsp.id}</div>
								// 		</div>
										
								// 		<div class="col-12 col-md-3 col-lg-3 order-md-3">
								// 			<div class="subtxt">{moment(this.props.createOrderStatusResponse.time).format('DD-MM-YYYY HH:mm:ss')}</div>
								// 		</div>
								// 	</div>
								// </div>
                                //  :txRsp.status=='FAILED' ?
								//  <div class="subtxn-failed">
									 
								//  <div class="row">
								// 	 <div class="col-6 col-md-3 col-lg-4 order-md-1">
								// 		 <div class="subtxt txnsts">Failed</div>
								// 	 </div>
									 
								// 	 <div class="col-6 col-md-2 col-lg-2 order-md-4">
								// 		 <div class="subtxt subamunt rtxt">₹ {txRsp.txnDetails.amount}</div>
								// 	 </div>
									 
								// 	 <div class="col-12 col-md-4 col-lg-3 order-md-2">
								// 		 <div class="subtxt subid">Transaction ID: {txRsp.id}</div>
								// 	 </div>
									 
								// 	 <div class="col-12 col-md-3 col-lg-3 order-md-3">
								// 	 <div class="subtxt">{moment(this.props.createOrderStatusResponse.time).format('DD-MM-YYYY HH:mm:ss')}</div>
								// 	 </div>
								//  </div>
							 	// </div>
								//  :txRsp.status=='REVERSED'  &&
								//  <div class="subtxn-failed">
									
								//  <div class="row">
								// 	 <div class="col-6 col-md-3 col-lg-4 order-md-1">
								// 		 <div class="subtxt txnsts">Failed</div>
								// 	 </div>
									 
								// 	 <div class="col-6 col-md-2 col-lg-2 order-md-4">
								// 		 <div class="subtxt subamunt rtxt">₹ {txRsp.txnDetails.amount}</div>
								// 	 </div>
									 
								// 	 <div class="col-12 col-md-4 col-lg-3 order-md-2">
								// 		 <div class="subtxt subid">Transaction ID: {txRsp.id}</div>
								// 	 </div>
									 
								// 	 <div class="col-12 col-md-3 col-lg-3 order-md-3">
								// 	 <div class="subtxt">{moment(this.props.createOrderStatusResponse.time).format('DD-MM-YYYY HH:mm:ss')}</div>
								// 	 </div>
								//  </div>
							 	// </div>

								))
							    
							}

											
	
							</div>


);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage},
	 miscReduce:{phone,createOrderRes,createOrderStatusResponse}
}) => ({
		errorMessage,loginErrorMessage,phone,createOrderRes,createOrderStatusResponse
});

export default connect(mapStateToProps, null)(SubTransactionDetails);